type PostcodeRange = [number, number]

// https://en.wikipedia.org/wiki/Postcodes_in_Australia#Allocation
const STATES = new Map<string, Array<PostcodeRange>>([
  [
    'NSW',
    [
      [1000, 1999],
      [2000, 2599],
      [2619, 2899],
      [2921, 2999],
    ],
  ],
  [
    'ACT',
    [
      [200, 299],
      [2600, 2618],
      [2900, 2920],
    ],
  ],
  [
    'VIC',
    [
      [3000, 3996],
      [8000, 8999],
    ],
  ],
  [
    'QLD',
    [
      [4000, 4999],
      [9000, 9999],
    ],
  ],
  [
    'SA',
    [
      [5000, 5799],
      [5800, 5999],
    ],
  ],
  [
    'WA',
    [
      [6000, 6797],
      [6800, 6999],
    ],
  ],
  [
    'TAS',
    [
      [7000, 7799],
      [7800, 7999],
    ],
  ],
  [
    'NT',
    [
      [800, 899],
      [900, 999],
    ],
  ],
])

export const postcodeToState = (postcode: string): string | undefined => {
  const p = Number.parseInt(postcode)

  if (isNaN(p)) {
    return undefined
  }

  for (const [state, ranges] of STATES) {
    for (const [min, max] of ranges) {
      if (p >= min && p <= max) {
        return state
      }
    }
  }

  return undefined
}
